/* global $, fantastiquebazar */

export default class LoadMore {
	constructor(element) {
		this.rootElement = element;

		this.append = this.append.bind(this);
		this.unlocked = this.unlocked.bind(this);
	}

	init() {
		this.$button = this.rootElement.querySelector('.js-button');
		this.$container = this.rootElement.querySelector('.js-container');

		this.foundPosts = parseFloat(this.rootElement.getAttribute('data-found-posts'));
		this.postsPerPage = parseFloat(this.rootElement.getAttribute('data-posts-per-page')) || 3;
		this.action = this.rootElement.getAttribute('data-action');
		this.offset = this.$container.children.length;
		this.loop = this.rootElement.getAttribute('data-loop');
		this.postNotIn = JSON.parse(this.rootElement.getAttribute('data-post-not-in')) || [];
		this.term = this.rootElement.getAttribute('data-term') || false;
		this.excludeTerm = this.rootElement.getAttribute('data-exclude-term') || false;

		return this.$button ? this.initEvents() : false;
	}

	initEvents() {
		// console.info('LoadMore.initEvents');

		this.$button.addEventListener('click', () => {
			this.load().then(this.append).done(this.unlocked);
		});
	}

	load() {
		this.locked();

		const data = {
			action: this.action,
			postsPerPage: this.postsPerPage,
			postNotIn: this.postNotIn,
			offset: this.offset,
			nonce: fantastiquebazar.nonce,
			term: this.term,
			excludeTerm: this.excludeTerm,
		};

		return $.ajax({
			url: fantastiquebazar.ajax_url,
			crossDomain: true,
			dataType: 'html',
			data,
		});
	}

	locked() {
		// console.info('unlocked.locked');

		if (this.postNotIn.length >= this.foundPosts) {
			this.postNotIn = [];
		}

		this.$button.classList.add('loading');
	}

	unlocked() {
		// console.info('LoadMore.unlocked');

		this.$button.classList.remove('loading');

		this.offset += this.postsPerPage;

		if (!this.loop && this.$button && this.offset >= this.foundPosts) {
			this.$button.style.setProperty('display', 'none');
		}

		if (this.loop && this.offset >= this.foundPosts) {
			this.offset = 0;
		}

		[...this.$container.children].map(item =>
			this.postNotIn.push(
				item.getAttribute('data-id') ? parseInt(item.getAttribute('data-id'), 10) : null,
			),
		);
		this.rootElement.setAttribute(
			'data-post-not-in',
			JSON.stringify(this.postNotIn.filter(Boolean)),
		);

		this.rootElement.dispatchEvent(new CustomEvent('unlocked'));
	}

	append(html) {
		if (this.loop) {
			this.$container.innerHTML = html;
		} else {
			this.$container.innerHTML += html;
		}
	}
}
